import React from 'react';
import { Briefcase } from 'lucide-react';
import ModuleTabHeader from '../../../components/common/ModuleTabHeader';

export type IdentityTabKey = 'positions' | 'processes' | 'compliances' | 'risks' | 'leave_balances';

export interface IdentityTabMeta {
  key: IdentityTabKey;
  label: string;
}

export const identityTabs: IdentityTabMeta[] = [
  { key: 'positions', label: 'My Positions' },
  { key: 'processes', label: 'My Processes' },
  { key: 'compliances', label: 'Compliances' },
  { key: 'risks', label: 'My Risks' },
  { key: 'leave_balances', label: 'My Leave Balances' },
];

interface IdentityTabsProps {
  activeTab: IdentityTabKey;
  onTabChange: (key: IdentityTabKey) => void;
  asideOpen: boolean;
  onAsideToggle: () => void;
}

const IdentityTabs: React.FC<IdentityTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <ModuleTabHeader
      title="Identity"
      icon={<Briefcase size={16} strokeWidth={1.75} />}
      tabs={identityTabs}
      activeTab={activeTab}
      onTabChange={(k: string) => onTabChange(k as IdentityTabKey)}
    />
  );
};

export default IdentityTabs;
